/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React from 'react';

import {StreamBankTable} from "../../../../Common/Table/StreamBankTable";

export const SpeciesTable = React.forwardRef((props, ref) => {
    
    const { columnDefinitions, sortColumn = null } = props;

    return <StreamBankTable
        columnDefs={columnDefinitions}
        itemNamePlural="species"
        getKeyForRow={x => x.speciesId}
        usesContext={false}
        clear
        pageSize={12}
        sortColumn={sortColumn ?? "scientificName"}
        sortAsc={true}

        ref={ref}

        {...props}
        filters={[
            // showAll
        ]}

    />;
});


